{
    "dottnet.home.change-theme": "Change Theme",
    "dottnet.home.check-blogs": "or check blogs home",
    "dottnet.home.contributors.description1": "Want to start contributing to open source with Angular?",
    "dottnet.home.contributors.description2": "Leave your mark and join the growing team of contributors!",
    "dottnet.home.contributors.description3": "Get started by having a look on ",
    "dottnet.home.contributors.description4": " and ",
    "dottnet.home.contributors.guide": "Contributor guide",
    "dottnet.home.contributors.issues": "open issues",
    "dottnet.home.contributors.title": "Contributors",
    "dottnet.home.get-notified.description": "a Twitter bot that helps you to stay up to date with releases of popular frontend frameworks & libraries!",
    "dottnet.home.get-notified.follow": "Follow",
    "dottnet.home.get-notified.title": "Get notified home new releases",
    "dottnet.home.get-started": "Get started",
    "dottnet.home.follow-us": "Follow us on",
    "dottnet.features.angular": "Modern powerful framework",
    "dottnet.features.angular-cli": "A command line interface for Angular",
    "dottnet.features.angular-material": "Material design component library",
    "dottnet.features.bootstrap": "Responsive layout from battle tested, world most famous UI library",
    "dottnet.features.cypress": "Cypress is a next generation front end testing tool built for the modern web.",
    "dottnet.features.documentation": "Docs",
    "dottnet.features.fontawesome": "Easy to use vector icons and social logos",
    "dottnet.features.guide": "Guide",
    "dottnet.features.lazyloading.description": "Faster startup time with lazy loaded feature modules",
    "dottnet.features.lazyloading.title": "Lazy loading",
    "dottnet.features.ngrx": "One way data flow powered by RxJS Observables",
    "dottnet.features.ngxtranslate": "An internationalization library for Angular",
    "dottnet.features.rxjs": "Reactive programming with async collections using Observables",
    "dottnet.features.themes.description": "Flexible theming support for provided and custom components",
    "dottnet.features.themes.title": "Themes",
    "dottnet.features.title": "Features",
    "dottnet.features.typescript": "Superior developer experience, code completion, refactoring and less bugs",
    "dottnet.features.eslint": "ESLint is for identifying problematic patterns found in JavaScript and Typescript code",
    "dottnet.footer.changelog": "Show changelog",
    "dottnet.header.github": "Project Github Repository",
    "dottnet.menu.home": "Home",
    "dottnet.menu.content": "Content",
    "dottnet.menu.news": "News",
    "dottnet.menu.document": "Documenti",
    "dottnet.menu.dossier": "Dossier",
    "dottnet.menu.video": "Video",
    "dottnet.menu.canale": "Canali",
    "dottnet.menu.minisito": "Minisiti",
    "dottnet.menu.offline": "Offline",
    "dottnet.menu.blog": "Blog",
    "dottnet.menu.professional": "Professionals - Corporate",
    "dottnet.menu.patient": "Patient association",
    "dottnet.menu.rarediseasepatient": "Rare disease patients association",
    "dottnet.menu.extra": "eXtra",
    "dottnet.menu.discoverextra": "Discover eXtra",
    "dottnet.menu.myextra": "My eXtra",
    "dottnet.menu.mycourses": "My courses",
    "dottnet.menu.articleextra": "eXtra articles",
    "dottnet.menu.privacybox": "Privacy box",
    "dottnet.menu.iframe": "Iframe",
    "dottnet.menu.toolbox": "Toolbox",
    "dottnet.menu.fad": "Fad",
    "dottnet.menu.pec": "Pec",
    "dottnet.menu.mail": "Mail",
    "dottnet.menu.list": "List",
    "dottnet.menu.examples": "Examples",
    "dottnet.menu.features": "Features",
    "dottnet.menu.accedi": "Sign in",
    "dottnet.menu.login": "Login",
    "dottnet.menu.signup": "Signup",
    "dottnet.menu.logout": "Logout",
    "dottnet.menu.settings": "Settings",
    "dottnet.menu.profile": "Profile",
    "dottnet.menu.managelog": "Manage logs",
    "dottnet.menu.schedario": "My Doctors",
    "dottnet.menu.ricerca": "Research",
    "dottnet.menu.ecm": "ECM",
    "dottnet.settings.animations.elements": "Navigation page elements slide up",
    "dottnet.settings.animations.page": "Navigation whole page transition",
    "dottnet.settings.animations.title": "Animations",
    "dottnet.settings.general.language.de": "German",
    "dottnet.settings.general.language.en": "English",
    "dottnet.settings.general.language.es": "Spanish",
    "dottnet.settings.general.language.fr": "French",
    "dottnet.settings.general.language.he": "Hebrew",
    "dottnet.settings.general.language.pt-br": "Portuguese",
    "dottnet.settings.general.language.sk": "Slovak",
    "dottnet.settings.general.language.zh-cn": "Simple Chinese",
    "dottnet.settings.general.placeholder": "Language",
    "dottnet.settings.general.title": "General",
    "dottnet.settings.themes.blue": "Blue",
    "dottnet.settings.themes.dark": "Dark",
    "dottnet.settings.themes.light": "Light",
    "dottnet.settings.themes.nature": "Nature",
    "dottnet.settings.themes.night-mode": "Auto night mode (from 21:00 to 7:00)",
    "dottnet.settings.themes.placeholder": "Color Theme",
    "dottnet.settings.themes.saneago": "",
    "dottnet.settings.themes.sticky-header": "Sticky header",
    "dottnet.settings.themes.title": "Themes",
    "dottnet.settings.title": "Settings",

    "dottnet.title.long": "DottNet",
    "dottnet.title.short": "DottNet",
    "dottnet.login.required": "Field must not be empty",
    "dottnet.login.username": "Email",
    "dottnet.login.password": "Password",
    "dottnet.login.rememberme": "Remember me",
    "dottnet.login.submit": "Submit",
    "dottnet.login.error": "There has been an error:",
    "dottnet.login.email": "Email:",
    "dottnet.login.pwd": "Retrieve Password",
    "dottnet.login.pwdforbidden": "Password Forbidden?",
    "dottnet.login.register": "Register",
    "dottnet.schedario.medici": "Doctors",
    "dottnet.schedario.cercamedici": "Search Doctor",
    "dottnet.schedario.carica": "Load",
    "dottnet.progettiazioni.selezionaprogettoazione": "Select Project and wave",
    "dottnet.progettiazioni.selezionaprogetto": "Select Project",
    "dottnet.progettiazioni.selezionaazione": "Select Wave",
    "dottnet.logs.searchtext": "Search logs",
    "dottnet.logs.delete": "DBLog purged. Deleted {{value}} records",
    "dottnet.shared.cerca": "Find...",
    "dottnet.shared.generic_select": "Select an option",
    "dottnet.shared.generic_placeholder": "Write...",
    "dottnet.shared.category": "Category",
    "dottnet.shared.specialty": "Specialty",
    "dottnet.shared.nessunrisultato": "No results",
    "dottnet.schedario.visite_ciclo": "Action visits",
    "dottnet.schedario.in_schedario": "My Doctors",
    "dottnet.schedario.personalizza_visite": "Visits",
    "dottnet.schedario.minimo_visite": "From",
    "dottnet.schedario.massimo_visite": "To",
    "dottnet.operatori.selezionaoperatore": "User",
    "dottnet.specializzazioni.selezionaspecializzazione": "Specialty",
    "dottnet.situazione-cliente": "Customer Details",
    "dottnet.situazione-cliente.short": "Cus. Details",
    "dottnet.domande-risposte": "Questions and answers",
    "dottnet.domande-risposte.select_istanza": "Select an istance",
    "dottnet.domande-risposte.select_date": "Select a date",
    "dottnet.domande-risposte.short": "Q&A",
    "dottnet.dottnet.last-login": "Last Login",
    "dottnet.dottnet.username": "Username",
    "dottnet.dottnet.password": "Password",
    "dottnet.dottnet.premium": "Premium",
    "dottnet.progettimail.selectmail": "Select mail",
    "dottnet.shared.required": "Required Field",
    "dottnet.shared.research": "Result Set",
    "dottnet.shared.emptyresults": "Non Results",
    "dottnet.filtri.selectfiltro": "Select Filter",
    "dottnet.shared.search": "Load",
    "dottnet.shared.id_anagrafica": "Id",
    "dottnet.shared.nome": "Name",
    "dottnet.shared.cognome": "Surname",
    "dottnet.shared.categoria": "Category",
    "dottnet.shared.listapersonale": "My List",
    "dottnet.shared.schedario": "My Doctors",
    "dottnet.shared.ricercasemplice": "Simple Search",
    "dottnet.shared.selezionacategoria": "Category",
    "dottnet.shared.provincia": "Province",
    "dottnet.shared.localita": "Country",
    "dottnet.shared.indirizzo": "Address",
    "dottnet.shared.email": "Email",
    "dottnet.shared.cf": "Fiscal Code",
    "dottnet.shared.recapito": "Phone Number",
    "dottnet.shared.ricercanagrafica": "Id",
    "dottnet.shared.ricercavanzata": "Advanced",
    "dottnet.shared.entita": "Entity",
    "dottnet.shared.assegnati": "Assigned",
    "dottnet.shared.reclutati": "Recluted",
    "dottnet.shared.searchselect": "Select a research method",
    "dottnet.shared.altro": "Other",
    "dottnet.shared.assistenza": "Something went wrong. Contact support.",
    "dottnet.shared.attenzione": "Attention",
    "dottnet.shared.moreContent": "More",
    "dottnet.wall.title": "Update User Informations",
    "dottnet.wall.dati_professionali": "Professional data",
    "dottnet.wall.consensi": "Consents *",
    "dottnet.wall.anagrafica": "Personal Infos",
    "dottnet.wall.accept": "Accept",
    "dottnet.wall.notaccept": "Not accept",
    "dottnet.wall.conditions": "Our terms of use are",
    "dottnet.wall.datainformative": "Our informations on the use of data (including the section dedicated to the use of cookies) are",
    "dottnet.wall.here": "here",
    "dottnet.wall.codicefiscale": "Fiscal code",
    "dottnet.wall.codiceBelfiore": "Belfiore code",
    "dottnet.wall.numeroIscrizioneAlbo": "Register year",
    "dottnet.wall.dataNascita": "Birth date",
    "dottnet.wall.nome": "First name",
    "dottnet.wall.cognome": "Last name",
    "dottnet.wall.fotoUtente": "User photo",
    "dottnet.wall.iconaUtente": "User icon",
    "dottnet.wall.sesso": "Sex",
    "dottnet.wall.provincia": "Province",
    "dottnet.wall.cap": "CAP",
    "dottnet.wall.anc": "Anc",
    "dottnet.wall.completaProfilo": "Complete Profile",
    "dottnet.wall.bodyConsent": "Dear user, we have made changes to our privacy policy to guarantee greater transparency and protection of your personal data. We therefore invite you to read our new  <a target='_blank' href='/privacy'>information</a>.",
    "dottnet.wall.bodyGeneral": "Before continuing, please consider completing the following fields",
    "dottnet.specialty.selezionaspecialty": "Select specialty",
    "dottnet.category.selezionacategory": "Select category",
    "dottnet.province.selezionaprovince": "Select province",
    "dottnet.pagina.piuletti": "Most read",
    "dottnet.pagina.ultimivideo": "Last videos",
    "dottnet.article.related": "Related",
    "dottnet.article.notmissed": "Not to be missed",
    "dottnet.article.interested": "You may be interested",
    "dottnet.article.latest": "Latest news",
    "dottnet.permessi.login": "Login required",
    "dottnet.permessi.unauthorizedTitle": "Unauthorized",
    "dottnet.permessi.unauthorized": "Dear user is not authorized to view the content",
    "dottnet.permessi.notFoundTitle": "Contento not found",
    "dottnet.permessi.activateMail": "Activate Account",
    "dottnet.permessi.notFound": "Dear user content not exists",
    "dottnet.permessi.sessionExpiredTitle": "Session Expired",
    "dottnet.permessi.sessionExpired": "Dear user, your session is expired. Please sign in through the following form",
    "dottnet.permessi.genericPermission": "Dear user login is required for this action",
    "dottnet.permessi.commentPermission": "Dear user login is required to comment",
    "dottnet.permessi.attenzione": "Attention",
    "dottnet.button.save": "Save",
    "dottnet.button.delete": "Delete",
    "dottnet.button.send": "Send",
    "dottnet.button.changePassword": "Change password",
    "dottnet.button.consents.fine": "All right",
    "dottnet.button.consents.consents": "Confirm",
    "dottnet.button.unsubscribe": "Unsubscribe",
    "dottnet.button.subscribe": "Subscribe",
    "dottnet.label.ecmInfos": "Ecm Infos",
    "dottnet.label.professionalInfos": "Professional Infos",
    "dottnet.label.yes": "Yes",
    "dottnet.label.no": "No",
    "dottnet.label.sponsor": "Sponsor indication",
    "dottnet.label.ecm": "ECM",
    "dottnet.label.name": "Name",
    "dottnet.label.cellulare": "Mobile Phone",
    "dottnet.label.cap": "CAP",
    "dottnet.label.surname": "Surname",
    "dottnet.label.email": "Email",
    "dottnet.label.password": "Password",
    "dottnet.label.codiceFiscale": "Country ID",
    "dottnet.label.birthdate": "Birthdate",
    "dottnet.label.bornAbroad": "Born outside of Italy",
    "dottnet.label.birthplace": "Birthplace",
    "dottnet.label.professionplace": "Profession place",
    "dottnet.label.professionType": "Activity place",
    "dottnet.label.agenasdisciplineType": "Discipline",
    "dottnet.label.birthplace.question": "Are you an Italian citizen born abroad?",
    "dottnet.label.gender": "Gender",
    "dottnet.label.gender.M": "Man",
    "dottnet.label.gender.F": "Woman",
    "dottnet.label.category": "Category",
    "dottnet.label.specialty": "Specialty",
    "dottnet.label.registerNumber": "Register entry number",
    "dottnet.label.registerCity": "Register entry city",
    "dottnet.label.consents.marketing": "Marketing",
    "dottnet.label.consents.marketingThirdParties": "Marketing Transfer Third Parties",
    "dottnet.label.consents.profiling": "Profiling",
    "dottnet.label.consents.profilingThirdParties": "Profiling Transfer Third Parties",

    "dottnet.title.comments": "Comments",
    "dottnet.field.label.comments": "What do you think about it?",
    "dottnet.field.label.comments.replying": "Replying to",
    "dottnet.field.label.comments.showMore": "{{numCommenti}} More",
    "dottnet.field.label.comments.reply": "Reply",
    "dottnet.field.label.comments.attachment": "No file uploaded yet",
    "dottnet.field.error.comments": "No blank comments please",

    "dottnet.label.oldPassword": "Old Password",
    "dottnet.label.newPassword": "New Password",
    "dottnet.label.confirmNewPassword": "Confirm New Password",

    "dottnet.consents.accept": "Accept",
    "dottnet.consents.reject": "Reject",
    "dottnet.consents.error": "Choose at least one option",

    "dottnet.hint.email": "Contact our customer care service to edit your email",
    "dottnet.hint.password": "The password must be 8 characters long of which at least an uppercase and lowercase character, one or more alphanumeric symbols",
    "dottnet.field.error.cellulare": "Not valid phone pattern",
    "dottnet.field.error.numeric": "Not valid number",
    "dottnet.field.error.required": "is a required field",
    "dottnet.field.error.email": "Type in a valid email. Example: mailaddress@example.com",
    "dottnet.field.error.mailExistence": "This address is already registered. Have you forgot your password?",
    "dottnet.field.error.cfExistence": "This ID is already present on our system. Do you need help? Contact our customer care service",
    "dottnet.field.error.cfLength": "The ID must be 16 characters long",
    "dottnet.field.error.password": "Type in a valid password. The password must be 8 characters long of which at least an uppercase and lowercase character, one or more alphanumeric symbols. Example: 9kY&epKG",
    "dottnet.field.error.invalidAge": "The user must be an adult",
    "dottnet.field.error.registerForm": "Register form fields are mandatory",
    "dottnet.field.error.consentsForm": "Fill the consents form entirely",
    "dottnet.field.error.passwordMismatch": "Password and Confirm Password must match",
    "dottnet.field.error.emptyObject": "Type some characters",

    "dottnet.home.medlex": "Medlex",
    "dottnet.home.bulletin": "Ministerial Bulletin",
    "dottnet.home.aifa": "Aifa",
    "dottnet.home.institutions": "Institutions",
    "dottnet.home.insights": "Insights",
    "dottnet.home.guideline": "Guideline",

    "dottnet.home.focusMedicina": "Focus on Med",
    "dottnet.home.focusVideo": "Highlighted Videos",

    "dottnet.dialog.consents.title": "Consensi",
    "dottnet.dialog.consents.marketing": "Solo previo Suo distinto ed esplicito consenso, al trattamento dei miei dati da parte del Titolare per le Finalità di Marketing di cui al punto 2.B) dell’Informativa (cioè per inviarmi comunicazioni e materiale pubblicitario o di vendita diretta di terzi soggetti, aventi contenuto commerciale, promozionale, pubblicitario e/o finalizzato all'informazione medico-scientifica; nonché per il compimento di ricerche di mercato, sondaggi d’opinione e analisi statistiche per finalità di marketing anche tramite raccolta del consenso per conto degli stessi. Il tutto può avvenire mediante l’uso di sistemi automatizzati di chiamata e/o email e/o fax e/o sms e/o mms e/o altri servizi di messaging e/o newsletter, e/o mediante modalità di marketing tradizionale come il telefono e/o posta cartacea)",
    "dottnet.dialog.consents.marketingThirdParties": "Solo previo Suo distinto ed esplicito consenso, alla comunicazione dei miei dati ai soggetti indicati all’art. 6 dell’Informativa, affinchè questi li trattino direttamente per le proprie Finalità di Marketing di cui al punto 2.D) dell’informativa  (ossia per inviarmi comunicazioni e materiale pubblicitario o di vendita diretta, aventi contenuto commerciale, promozionale, pubblicitario e/o finalizzato all'informazione medico-scientifica; nonché per il compimento di ricerche di mercato, sondaggi d’opinione e analisi statistiche per finalità di marketing. Il tutto mediante l’uso di sistemi automatizzati di chiamata e/o email e/o fax e/o sms e/o mms e/o altri servizi di messaging e/o newsletter, e/o mediante modalità di marketing tradizionale telefono e/o posta cartacea)",
    "dottnet.dialog.consents.profiling": "Solo previo Suo distinto ed esplicito consenso, al trattamento dei miei dati da parte del Titolare per le Finalità di Profilazione di cui al punto 2.C) dell’Informativa (cioè per analisi delle mie abitudini e scelte di consumo, di acquisto e professionali, svolte attraverso operazioni di segmentazione e tramite raccolta e analisi di sottogruppi di medici in base alle loro abitudini di navigazione, all’età ed alla specializzazione, volti unicamente ad orientare nel modo migliore la proposta di contenuti ed iniziative alle preferenze dell’utente, e ad evitare di proporgli argomenti non di suo interesse, ai fini dell’invio di comunicazioni e materiale pubblicitario o di vendita diretta su prodotti/servizi/iniziative e/o ricerche di mercato e/o sondaggi d’opinione e/o analisi statistiche di terzi soggetti, anche mediante l’uso di sistemi automatizzati di chiamata e/o email e/o fax e/o sms e/o mms e/o altri servizi di messaging e/o newsletter e/o telefono e/o posta cartacea)",
    "dottnet.dialog.consents.profilingThirdParties": "Solo previo Suo distinto ed esplicito consenso, alla comunicazione dei miei dati ai soggetti indicati all’art. 6 dell’Informativa, affinchè questi li trattino direttamente per le proprie Finalità di Profilazione di cui al punto 2.E) dell’informativa con annessa categoria e appartenenza ai“ gruppi” ai fini di svolgimento delle proprie attività di profilazione(finalizzate allo svolgimento da parte dei terzi di proprie analisi, invio di newsletter e sondaggi, comunicazioni di marketing diretto) anche mediante l’ uso di sistemi automatizzati di chiamata e / o email e / o fax e / o sms e / o mms e / o altri servizi di messaging e / o newsletter e / o telefono e / o posta cartacea)",

    "dottnet.notification.success": "Operation performed successfully",
    "dottnet.notification.error": "Operation failed! Retry please",
    "dottnet.notification.ok": "OK",

    "dottnet.lista.leggi": "Read",
    "dottnet.lista.guarda": "Watch",
    "dottnet.lista.apri": "Open",

    "dottnet.confirmMail.text": "To fully activate your account, please click on the link we sent to your email address. Haven't received your verification email? Click on the button below!",
    "dottnet.confirmMail.text.expired": "We're sorry but the link you followed is expired. Please, get another activation link clicking the button below.",
    "dottnet.confirmMail.button": "Send Mail",
    "dottnet.confirmMail.returnToDrClick": "Back To DrClick",

    "dottnet.text.welcome": "Welcome to DottNet!",
    "dottnet.text.sign": "DottNet Team",

    "dottnet.log.text": "Dear User, this page allows us to give you the best assistance through specific tools. If you need to get in touch with our Customer Care Service, please contact us at: XXXXXXXXXXXXXXX",
    "dottnet.log.empty": "No logs found",
    "dottnet.log.records": "There are ",
    "dottnet.log.delete": "To delete Dottnet's log  ",
    "dottnet.log.send": "To send DottNet's logs to customer care ",
    "dottnet.log.reload": "Reload",

    "dottnet.message.retrievepassword": "Password successfully retreived! Check your email",
    "dottnet.message.changedpassword": "Password successfully changed!",
    "dottnet.message.activationMailSent": "Activation mail successfully sent!",

    "dottnet.error.11": "Username or password wrong",
    "dottnet.error.24": "Empty username or password",
    "dottnet.error.44": "SiteId not found",
    "dottnet.error.45": "Deleted User",
    "dottnet.error.46": "Specialty not registered for site id",
    "dottnet.error.47": "Category not registered for site id",
    "dottnet.error.48": "User not registered for site id",
    "dottnet.error.49": "Privacy consent missing",
    "dottnet.error.50": "Marketing consent missing",
    "dottnet.error.51": "Profiling consent missing",
    "dottnet.error.52": "Marketing to third parts consent missingd",
    "dottnet.error.53": "Profiling to third parts  consent missing",
    "dottnet.error.100": "Dear User, session tracking is not available in incognito mode",

    "dottnet.search.title": "Results for",
    "dottnet.search.wordlist": "Found with:",
    "dottnet.search.containerinfo": "in",
    "dottnet.search.toofewcharacters": "Insert at least 3 characters",

    "dottnet.consent.header": "We value your privacy",
    "dottnet.consent.body": "We and our partners use technologies such as cookies or targeting and process personal data such as IP address or browser information to personalise the ads we display. These technologies may access your device and help us show you more relevant ads and improve your website experience. We also use these technologies to measure results or better target our website content. Because we value your privacy, we hereby ask for your consent to use the following technologies. You can change/revoke this at any time later by clicking on the Settings button in the bottom left corner of the page.",
    "dottnet.consent.privacy_text": "Privacy policy",
    "dottnet.consent.imprint_text": "Imprint",
    "dottnet.consent.privacy_settings_text": "Privacy settings",
    "dottnet.consent.decline_text": "DENY",
    "dottnet.consent.accept_text": "ACCEPT AND CLOSE",
    "dottnet.consent.save_text": "SAVE",
    "dottnet.consent.back_text": "Back",
    "dottnet.consent.privacy_settings_title": "Privacy Settings",
    "dottnet.consent.privacy_settings_title_text": "This tool helps you to select and deactivate various cookies, trackers and analysis tools used on this website.",
    "dottnet.consent.functional_title": "Functional",
    "dottnet.consent.functional_description": "These cookies enable us to analyze website usage so that we can measure and improve its performance.",
    "dottnet.consent.marketing_title": "Marketing",
    "dottnet.consent.marketing_description": "Marketing cookies are usually used to show you advertisements that meet your interests. When you visit another website, your browser's cookie is recognized and selected ads are displayed to you based on the information stored in this cookie (art. 6 par. 1 p. 1 a) GDPR).",
    "dottnet.consent.essential_title": "Essential",
    "dottnet.consent.essential_description": "These cookies are required for the basic functions of the website.",
    "dottnet.consent.cookie_name": "Name",
    "dottnet.consent.cookie_description": "Description",
    "dottnet.consent.cookie_duration": "Duration",
    "dottnet.consent.right_bottom": "You can change/revoke this at any time later by clicking on the Settings button in the bottom right corner of the page.",
    "dottnet.consent.left_bottom": "You can change/revoke this at any time later by clicking on the Settings button in the bottom left corner of the page.",
    "dottnet.consent.right_top": "You can change/revoke this at any time later by clicking on the Settings button in the top right corner of the page.",
    "dottnet.consent.left_top": "You can change/revoke this at any time later by clicking on the Settings button in the top left corner of the page.",

    "dottnet.consent.functionalCookies.name": "Google Analytics",
    "dottnet.consent.functionalCookies.description": "Google Analytics is a web analytics service offered by Google that tracks and reports website traffic.",
    "dottnet.consent.marketingCookiesGa.name": "Google Analytics",
    "dottnet.consent.marketingCookiesGa.description": "Google Analytics is a web analytics service offered by Google that tracks and reports website traffic.",
    "dottnet.consent.marketingCookiesGa.privacyPolicyUrl": "https://policies.google.com/privacy?hl=it",
    "dottnet.consent.marketingCookiesMeta.name": "Meta",
    "dottnet.consent.marketingCookiesMeta.description": "Meta is a US company that controls the social networking services Facebook and Instagram.",
    "dottnet.consent.marketingCookiesMeta.privacyPolicyUrl": " https://www.facebook.com/privacy/policies/cookies/",
    "dottnet.consent.functionalCookies.privacyPolicyUrl": "https://policies.google.com/privacy",
    "dottnet.consent.functionalCookiesGA.description": "This cookie is used to distinguish users.",
    "dottnet.consent.functionalCookiesGA.duration": "2 years",
    "dottnet.consent.functionalCookiesGID.description": "This cookie is used to distinguish users.",
    "dottnet.consent.functionalCookiesGID.duration": "24 hours",
    "dottnet.consent.functionalCookiesGAT.description": "This cookie is used to throttle request rate.",
    "dottnet.consent.functionalCookiesGAT.duration": "1 minute",
    "dottnet.consent.functionalCookiesGTAG.description": "This cookie is used to throttle request rate.",
    "dottnet.consent.functionalCookiesGTAG.duration": "1 minute",
    "dottnet.consent.functionalCookiesTOKEN.description": "This cookie is used to throttle request rate.",
    "dottnet.consent.functionalCookiesTOKEN.duration": "1 minute",
    "dottnet.consent.marketingCookiesGaGA.description": "This cookie is used to distinguish users.",
    "dottnet.consent.marketingCookiesGaGA.duration": "2 years",
    "dottnet.consent.essentialCookies.description": "This cookie is used to ensure the correct functioning of dottnet.it",
    "dottnet.consent.essentialCookies.privacyPolicyUrl": "https://www.dottnet.it/privacy",
    "dottnet.consent.thirdpartyconsent.accepted": "we have registered consent you have given to: ",
    "dottnet.consent.thirdpartyconsent.failed": "Error registering consent. Try again",
    "dottnet.disiscrizione.single": "Unsubscribe from newsletter",
    "dottnet.disiscrizione.all": "Unsubscribe from all newsletters",
    "dottnet.disiscrizione.allTitle": "Newsletter Unsubscription",
    "dottnet.disiscrizione.dottnet": "Unsubscribe from DottNet",
    "dottnet.disiscrizione.dottnetTitle": "DottNet Unsubscription",
    "dottnet.disiscrizione.conferma": "Unsubscribe",
    "dottnet.disiscrizione.annulla": "Cancel",
    "dottnet.disiscrizione.allIntention": "To unsubscribe from all newsletters click here",
    "dottnet.disiscrizione.dottnetIntention": "To unsubscribe from a DottNet click here",
    "dottnet.disiscrizione.unknowUser": "Unknow User",
    "dottnet.disiscrizione.unknowUserDescription": "To unsubscribe, you need to login.",
    "dottnet.disiscrizione.login": "To login, click here.",
    "dottnet.iscrizione.title": "Succesfully subscribed",
    "dottnet.iscrizione.unknowUserDescription": "To subscribe, you need to login.",
    "dottnet.iscrizione.remove": "Click here to undo.",
    "dottnet.footer.chiSiamo": "Company",
    "dottnet.footer.redazione": "Staff",
    "dottnet.footer.contatti": "Contacts",
    "dottnet.footer.seguici": "follow us",
    "dottnet.footer.numeroVerde": "Free call number 800 014 863",
    "dottnet.footer.honCode": " ",
    "dottnet.footer.honCode2": "HONcode certification",
    "dottnet.footer.check": "Click here.",
    "dottnet.footer.condizioni": "Terms of use",
    "dottnet.footer.privacy": "Privacy Policy",
    "dottnet.footer.cancellazione": "Unsubscribe",
    "dottnet.footer.company": "Merqurio Editore s.r.l. - Partita IVA: 05877761212 ",

    "dottnet.extra.duration_3": "/ 3 months",
    "dottnet.extra.duration_6": "/ 6 months",
    "dottnet.extra.duration_9": "/ 9 months",
    "dottnet.extra.duration_12": "/ 1 year",
    "dottnet.extra.duration_24": "/ 2 year",
    "dottnet.extra.duration_default": " months",
    "dottnet.extra.invoice": "Do you want the invoice?",
    "dottnet.extra.invoiceDetail": "Insert VAT number PEC or SD.",
    "dottnet.extra.invoiceVat": "Insert VAT Number",
    "dottnet.extra.invoicePec": "Insert Pec.",
    "dottnet.extra.invoiceSd": "Insert SD",
    "dottnet.extra.Vat": "VAT Number",
    "dottnet.extra.Pec": "Pec",
    "dottnet.extra.Sd": "SD",
    "dottnet.extra.total": "TOTAL:",
    "dottnet.extra.finalTotal": "(Effective TOTAL):",
    "dottnet.extra.finalTotalCondition": "Your subscription expires on",
    "dottnet.extra.finalTotalCondition2": ". Rather than ",
    "dottnet.extra.finalTotalCondition3": "€ we will charge you ",
    "dottnet.extra.finalTotalCondition4": "€ to supplement your existing subscription.",
    "dottnet.extra.terms": "Terms and conditions",
    "dottnet.extra.condition": "Read and approve the Terms of Service. By clicking on Continue you declare that you have read and specifically approved articles 1 to 16 of the Special conditions of the ",
    "dottnet.extra.condition2": "Service",
    "dottnet.extra.prosegui": "Next",
    "dottnet.extra.paga": "Pay",
    "dottnet.extra.coming": "Cooming soon",
    "dottnet.extra.valuta": "€",
    "dottnet.extra.codiceSconto": "Discount Code",
    "dottnet.extra.applicaSconto": "Apply",
    "dottnet.extra.personalization": "Personalize your subscription",
    "dottnet.extra.login": "Login to discover Dottnet eXtra",
    "dottnet.extra.payment.email": "Email",
    "dottnet.extra.payment.name": "Name",
    "dottnet.extra.payment.processing": "Processing",
    "dottnet.extra.payment.pay": "Pay",
    "dottnet.extra.sellerFormAnagrafica": "Insert UserId",
    "dottnet.extra.sellerFormNome": "Name",
    "dottnet.extra.sellerFormCognome": "Surname",
    "dottnet.extra.sellerFormMail": "Mail",
    "dottnet.extra.sellerFormPremium": "Premium",
    "dottnet.extra.sellerFormDataInizio": "Subscription Start",
    "dottnet.extra.sellerFormDataFine": "Subscription End",
    "dottnet.extra.sellerFormCarica": "Load",
    "dottnet.extra.sellerAbbonato": "Premium User",
    "dottnet.extra.sellerNonAbbonato": "NOT Premium User",
    "dottnet.extra.selectCoupon": "Select Coupon",
    "dottnet.extra.createCoupon": "CREATE COUPON",
    "dottnet.extra.deleteSubscriptionAll": "Delete Subscrition on end time",
    "dottnet.extra.deleteSubscription": "Delete item Subscrition on end time",
    "dottnet.extra.activateSubscription": "Enable Subscrition on end time",
    "dottnet.extra.reserved": "Reserved content to Dottnet eXtra subscribers",
    "dottnet.extra.base": "<h1> DottNet eXtra</h1> <p>Lo strumento unico che facilita e migliora il tuo aggiornamento e la tua professione.</p><p>Abbiamo voluto creare qualcosa di completamente nuovo, ma solo dopo aver ascoltato i suggerimenti di migliaia di colleghi medici su tutto il territorio Nazionale.</p><p> Così nasce questo spazio, <strong> riservato a chi vuole trovare solo contenuti ad altissimo valore scientifico e soluzioni professionali al massimo livello.</strong>Il tutto con la piena ed assoluta libertà di scelta senza alcuna imposizione di prodotto o servizio.</p><p><strong>Con DottNet eXtra sei tu il vero protagonista.</strong> Scegli in totale autonomia solo ciò che vuoi, quando vuoi. Così anche il costo della tua iscrizione lo decidi tu. Soluzioni uniche in tutti gli ambiti:</p><ul><li><strong>Articoli scientifici completi</strong> ad altissimo valore aggiunto</li><li><strong>Adeguamento Privacy del Medico</strong> secondo <strong>GDPR</strong></li><li><strong>Consulenza specializzata in ambito previdenziale</strong></li><li><strong>Credito privilegiato</strong> con i finanziamenti unici di Club Medici</li> <li> <strong>Tutela legale a massimale illimitato</strong> per anno e per sinistro (con la scelta del legale nel circuito specializzato Legal Service) </li><li><strong>Consulenza e condizioni assicurative esclusive</strong> grazie al circuito MedicoProtetto.</li></ul><p> Scopri questo e molto altro nello <strong>spazio pensato per te.</strong> Scegli ciò che ti interessa ed entra subito in DottNet eXtra.</p>",
    "dottnet.extra.welcome": "<h1> DottNet eXtra</h1> <p>Abbonamento attivato correttamente.</p><p>Benvenuto nello spazio <strong> riservato a chi vuole trovare solo contenuti ad altissimo valore scientifico e soluzioni professionali al massimo livello.</strong></p>",
    "dottnet.extra.entra": "Come in",
    "dottnet.extra.dtnExtra": "DottNet eXtra",
    "dottnet.extra.support": "Need you support?",
    "dottnet.extra.call": "Call us to free number:",
    "dottnet.extra.freenumber": "800.072.636",
    "dottnet.extra.codutente": "User code",
    "dottnet.extra.totalEcm": "Total ECM score:",
    "dottnet.extra.availabelEcm": "Avalaible ECM score:",
    "dottnet.extra.subscriptionFrom": "Subscription active from",
    "dottnet.extra.subscriptionTo": "Subscription end",
    "dottnet.extra.mycourses": "My courses",
    "dottnet.extra.extraArticle": "Extra Articles",
    "dottnet.extra.subscriptionOk": "Subscription activated successfully",
    "dottnet.extra.subscriptionKo": "Something went wrong during the process. Please, contact our customer care service. Nothing was charged",
    "dottnet.extra.deactivated": "Deactivated plan",
    "dottnet.extra.error": "Something went wrong.Please, contact our customer care service.",
    "dottnet.extra.invalidStatus": "Something went wrong.Invalid payment status.Please, contact our customer care service. Payment Status: ",
    "dottnet.extra.disdetta": "Success Cancellation!",
    "dottnet.extra.subscriptionExists": "Attention. You are already subscribed to the chosen plans.",
    "dottnet.shared.error": "Something went wrong",
    "dottnet.userform.intro": "By registering with Dottnet you accept ours",
    "dottnet.userform.condition": "Conditions",
    "dottnet.userform.intro2": "You also confirm that you have read ",
    "dottnet.userform.privacy": "information",
    "dottnet.userform.intro3": "on the use of data, including the section dedicated to the use of cookies.",
    "dottnet.notfound.h2": "Oops! Nothing was found",
    "dottnet.notfound.p": "The page you are looking for might have been removed had its name changed or is temporarily unavailable.",
    "dottnet.notfound.a": "Return to homepage",
    "dottnet.label.read": "Read",
    "dottnet.label.watch": "Watch",
    "dottnet.profile.reserved": "Dear User, sign in before accessing your profile area",
    "dottnet.pdf.alertDownload": "Dear User, the PDF file is not donwloadable.",
    "dottnet.pdf.alertPrint": "Dear User, the PDF file is not printable.",
    "dottnet.errorcode.78": "Insufficient Funds.",
    "dottnet.errorcode.79": "Lost Card.",
    "dottnet.errorcode.80": "Stolen Card.",
    "dottnet.errorcode.81": "Expired Card.",
    "dottnet.errorcode.82": "Incorrect CVC.",
    "dottnet.errorcode.83": "Incorrect Number.",

    "dottnet.errorcode.85": "Failed to enroll user. Error enrolling user.",
    "dottnet.errorcode.86": "Failed to enroll user. Error saving external consent for fad enrollment.",
    "dottnet.errorcode.87": "Failed to enroll user. Error saving ecm info for fad enrollment.",

    "dottnet.shared.affermativo": "Yes",
    "dottnet.shared.negativo": "No",
    "dottnet.enrollement.ecm": "Credit release",
    "dottnet.enrollement.enroll": "Enrolled*",
    "dottnet.enrollement.registration": "Register",
    "dottnet.enrollement.enrollLable": "*The healthcare professional who, for participation in training events, benefits from direct and indirect economic and non-economic advantages from commercial companies operating in the healthcare sector is considered to have been recruited.",
    "dottnet.enrollement.registrationLable": "Registration",
    "dottnet.enrollement.enrollSuccess": "Succesfull registration. Check your email.",
    "dottnet.enrollement.enrolled": "Dear user, you are already enrolled to this course. Check your email. Send email again.",
    "dottnet.poll.votes": "votes",
    "dottnet.poll.expiry": "expiry days",
    "dottnet.poll.undo": "Undo",
    "dottnet.poll.closed": "Closed",
    "dottnet.repblog.noinfo": "Sorry, we don't have any informants assigned to your area.",
    "dottnet.repblog.welcome1": "Welcome to the area dedicated to video calls,",
    "dottnet.repblog.welcome2": "to enter into a direct relationship with an Informant",
    "dottnet.repblog.info1": "For more information,",
    "dottnet.repblog.info2": "you can contact the toll-free number:",
    "dottnet.repblog.info3": "800 014 863",
    "dottnet.meta.website.description": "DottNet is a medical portal with news, studies and insights for health professionals.",
    "dottnet.meta.organization.description": "DottNet is a medical portal with news, studies, webinars and insights for doctors, pharmacists and healthcare professionals.",
    "dottnet.meta.organization.legalName": "Merqurio Editore s.r.l.",
    "dottnet.meta.organization.streetAddress": "Corso Umberto I, 23",
    "dottnet.meta.organization.addressLocality": "Napoli",
    "dottnet.meta.organization.postalCode": "80138",
    "dottnet.meta.organization.addressCountry": "IT",
    "dottnet.meta.contacts.telephone": "800.014.863",
    "dottnet.meta.contacts.email": "redazione@merqurio.it",
    "dottnet.meta.organization.department.name": "Redazione",
      "dottnet.label.evidenza": "Highlighted",
    "dottnet.label.account.signign": "Don't have an account?",
    "dottnet.placeholder.date": "MM/DD/YYYY",
    "dottnet.countdown.days": "Days",
    "dottnet.countdown.hours": "Hours",
    "dottnet.countdown.minutes": "Minutes",
    "dottnet.countdown.seconds": "Seconds",
  "dottnet.dropdownMidgetMenu.defaultTitle": "Menu",
  "dottnet.pec.title": "PEC DottNet",
  "dottnet.pec.label": "Dear user, your certified email address is not configured."

}
